<template lang="pug">
    form-group-layout.select-field(:label='label' v-bind='$attrs')
        template(v-slot='{invalid, errors, touch}')
            label(v-if='!hideLabel && label') {{ label }}

            div.select-field__container
                div.select-field__container-field
                    vue-select.form-control(v-model='model' :options='options' label='name' :reduce='valueReduce'
                            :appendToBody='true' :calculatePosition='positionOptions'
                            :placeholder='placeholder' :disabled='disabled' :invalid='invalid'
                            :clearable='false' :searchable='false' :filterable='false'
                            :inputId="name"
                            @input='touch')
                        template(#search='{attributes, events}')
                            input(class='vs__search' v-bind='attributes' v-on='events' :style='vsSearchStyle(attributes)' ref='searchField')
                        template(#no-options) {{ noOptionsText }}

                    inline-error-control(:errors='errors' :relative='true')
                div.select-field__container-tooltip(v-if='tooltip')
                    tooltip-control(:tooltip='tooltip')
</template>

<script>
import vueSelect from 'vue-select'
import { createPopper } from '@popperjs/core'

export default {
    name: 'select-field',
    components: {
        'vue-select': vueSelect,
    },
    props: {
        name: [String],
        value: [String, Number],
        options: Array,
        label: String,
        hideLabel: Boolean,
        placeholder: String,
        disabled: Boolean,
        tooltip: {
            type: String,
        },
        noOptionsText: {
            type: String,
            default() { return 'Sorry, no matching options.' },
        },
    },
    computed: {
        model: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
                this.$emit('change', val)
            },
        },
    },
    methods: {
        valueReduce(o) {
            return o.value
        },
        positionOptions(dropdownList, component, {width}) {
            dropdownList.style.minWidth = width

            const popper = createPopper(component.$refs.toggle, dropdownList, {
                placement: 'bottom',
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [0, 2],
                        },
                    },
                    {
                        name: 'preventOverflow',
                        options: {
                            padding: 10,
                        },
                    },
                ],
            })

            return () => popper.destroy()
        },
        vsSearchStyle(attributes) {
            if (!attributes.placeholder) {
                return { opacity: 0 }
            }
        },

        openList() {
            this.$refs.searchField.focus()
        },
    },
}
</script>
